// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3LOn7","ranges":"BmiRanges_ranges__2tylq"};